import { environment } from "../../environments/environment";

export const loginApi = {
  attemptAuth: `${environment.api_url}/rest/users/authenticate`,
  checkTokenExpiry: `${environment.api_url}/rest/token/checkIfExpired`,
  logout: `${environment.api_url}/rest/users/logout`,
  getEndpointUrl(endpoint) {
    return `${environment.oidc.domain}${environment.oidc.endPoints[
      endpoint
    ].replace("<client_id>", environment.oidc.clientId)}`;
  },
  get issuer() {
    return this.getEndpointUrl("issuer");
  },
  get authorizationUrl() {
    return this.getEndpointUrl("authorize");
  },
  get tokenUrl() {
    return this.getEndpointUrl("token");
  },
  get userInfoUrl() {
    return this.getEndpointUrl("userInfo");
  },
  get logoutUrl() {
    return this.getEndpointUrl("logout");
  },
};

export const profileApi = {
  getAllRoles: `${environment.api_url}/rest/userRoles/all`,
  getProfile: `${environment.api_url}/rest/users/search/findByUsername`,
  updateProfile: `${environment.api_url}/rest/users`,
  postProfilePic: `${environment.api_url}/rest/users/profilePic`,
  getEmailVerify: `${environment.api_url}/rest/users/verifyEmail/resend/`,
  resendApprovalEmail: `${environment.api_url}/rest/users/approveUser/resend/`,
  verifyEmail: `${environment.api_url}/rest/users/verifyEmail/`,
  approveUserRole: `${environment.api_url}/rest/users/approveUser/`,
  companyAllUsers: `${environment.api_url}/rest/users/company/`,
  updatePamProfile: `${environment.api_url}/rest/users/createPam`,
  getpamActivityData: `${environment.api_url}/rest/activities`,
  updateWelcomePageData: `${environment.api_url}/rest/activities`,
  getDataToken: `${environment.api_url}/bunchball/rest/auth-token`,
  setTokenUserName: `${environment.api_url}/bunchball/rest/action`,
  pamActivityProgress: `${environment.api_url}/rest/pamActivityProgress`,
  approveChallenge: `${environment.api_url}/rest/customChallenge/approveChallenge`,
  uploadAttachedDocument: `${environment.api_url}/rest/customChallenge/uploadAttachedDocument`,
  unsubscribeUser: `${environment.api_url}/rest/emailNotifications/unrestricted/unsubscribe/user`,
  emailNotificationType: `${environment.api_url}/rest/emailNotifications/unrestricted/type/`,
};

export const dashboardApi = {
  getSellerDashboardFull: `${environment.api_url}/rest/dashboard/seller/full/`,
  getManagerDashboardFull: `${environment.api_url}/rest/dashboard/manager/full/`,
  // getNotifications: `${environment.api_url}/rest/notifications`,
  getNotifications: `${environment.api_url}/rest/notifications/list`,
  postDeleteNotification: `${environment.api_url}/rest/notifications`,
  getSellerChallenges: `${environment.api_url}/rest/dashboard/seller/challenges/`,
  getManagerActivationChallenges: `${environment.api_url}/rest/dashboard/manager/managerActivationChallenges/`,
  postBudgetStatsCaps: `${environment.api_url}/rest/budgetCap/getRewardCapStats`,
  updateNotification: `${environment.api_url}/rest/notifications/updateByPage`,
  getNotificationsCount: `${environment.api_url}/rest/notifications/count`,
  quarterList: `${environment.api_url}/rest/dashboard/quarters/select/options`,
};

export const leaderboardApi = {
  getSalesLeaderboardList: `${environment.api_url}/rest/customChallenge/salesChallenges/`,
  getSalesLeaderboardData: `${environment.api_url}/rest/leaderboard/salesChallenges/company/`,
  getGeneralLeaderboard: `${environment.api_url}/rest/leaderboard/general/company/`,
  getMngrChallngLdbrd: `${environment.api_url}/rest/leaderboard/challenges/manager/`,
  getSellerChallngLdbrd: `${environment.api_url}/rest/leaderboard/challenges/seller/`,
  getMoreChallenges: `${environment.api_url}/rest/leaderboard/challenges/`,
  getActivationChallenges: `${environment.api_url}/rest/leaderboard/challenges/activation/`,
  // getTopCiscoBookings: `${environment.api_url}/rest/leaderboard/general/company/fiscalquarter/fiscalyear/`,
  getTopCiscoBookings: `${environment.api_url}/rest/leaderboard/sellerTotalPerformanceExport`,
  getFiscalDropDownList: `${environment.api_url}/rest/leaderboard/general/topciscobookings/select/options`,
  getFiscalPamDropdownList: `${environment.api_url}/rest/leaderboard/partnersTotalPeformance/select/options`,
  getPartnersLeaderboardData: `${environment.api_url}/rest/leaderboard/partnersTotalPerformanceExport`,
  sellerTotalPerformanceExport: `${environment.api_url}/rest/leaderboard/sellerTotalPerformanceExport{param}`,
  partnersTotalPerformanceExport: `${environment.api_url}/rest/leaderboard/partnersTotalPerformanceExport{param}`,
  distributionLeaderboard: `${environment.api_url}/rest/leaderboard/distiChallenge`,
  leaderboardQuaterList: `${environment.api_url}/rest/leaderboard/quarters/select/options?`,
  LeaderboardChallenges: `${environment.api_url}/rest/leaderboardChallenges`,
  activityLeaderboardChagTypes: `${environment.api_url}/rest/challengeTypes?includeInternal=false&leaderboard=true`,
  activityLeaderboardSubCategory: `${environment.api_url}/rest/leaderboard/prdBkgActCh/targetDetails/`,
  leaderboardChallengeData: `${environment.api_url}/rest/leaderboardChallenges/productBooking/`,
  leaderboardChgsSubcategoryData: `${environment.api_url}/rest/leaderboardChallenges/prdBkgCh/targetDetails/`,
  leaderboardRankDetails: `${environment.api_url}/rest/leaderboardChallenges/prdBkgCh/rank/`,
  activityLeaderboardRankDetails: `${environment.api_url}/rest/leaderboard/prdBkgActCh/rank/`,
  uploadLeaderboardDocuments: `${environment.api_url}/rest/leaderboardChallenges/uploadAttachment`,
};

export const sellerApi = {
  getStandardIncentives: `${environment.api_url}/rest/incentives/type/STANDARD`,
  getBonusIncentives: `${environment.api_url}/rest/incentives/type/BONUS`,
  activityDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/activityChallengeDeals`,
  salesDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/salesChallengeDeals`,
  claimedDeals: `${environment.api_url}/rest/claims/seller/pointsClaimedAndEarnedHistory`,
  pendingClaimedDeals: `${environment.api_url}/rest/eligibleDeals/user/pending`,
  getOtherChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company`,
  getOtherChallengeCount: `${environment.api_url}/rest/eligibleDeals/otherDeals/claimedCount`,
  claimDeal: `${environment.api_url}/rest/claims/claim/deal/`,
  getPointsAvailable: `${environment.api_url}/rest/points/user/available`,
  getCreditsAvailable: `${environment.api_url}/rest/credits/user/available`,
  getPointsGrsUrlForUser: `${environment.redeemptionUrl}/rest/incentives/redeem/points`,
  getCreditsGrsUrlForUser: `${environment.api_url}/rest/incentives/redeem/credits`,
  getPrescribedEnablementsSeller: `${environment.api_url}/rest/prescribedenablements/seller`,
  getSaleChallengesSeller: `${environment.api_url}/rest/activityChallenges/seller`,
  claimDealByPo: `${environment.api_url}/rest/claims/claim/ponumber`,
  coursesTakeClass: `${environment.api_url}/rest/courses/takeClass`,
  deleteChallenge: `${environment.api_url}/rest/challenges/delete`,
  centerDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/dataCenterChallengeDeals`,
  blackBeltDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/blackBeltChallengeDeals`,
  blackBeltIOTDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/blackBeltIOTChallengeDeals`,
  nexuscenterDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/nexusChallengeDeals`,
  pointTransactionHistory: `${environment.api_url}/rest/points/user/pointsTransactionHistory`,
  ticketTransactionHistory: `${environment.api_url}/rest/credits/user/availableCreditsHistory`,
  securitySpringDealToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/securitySprintChallengeDeals`,
  collaborationSprintDealToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/collaborationSprintChallengeDeals`,
  cloudCallingToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/cloudCallingChallengeDeals`,
  getTicketRedemption: `${environment.api_url}/rest/catalogs/catalog/findByUser`,
  redeemTicketCatalog: `${environment.api_url}/rest/ticketredemption/redeem/catalogitem`,
  merakiToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/blackBeltMerakiChallengeDeals`,
  dnaToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/dnacApplianceChallengeDeals`,
  wanToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/competitiveTakeoutChallengeDeals`,
  saseToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/saseChallengeDeals`,
  ibnToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/ibnWanChallengeDeals`,
  eaToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/enterpriseAgreementsAccelerationRewardsChallengeDeals`,
  officeToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/returnToOfficeChallengeDeals`,
  iotsalesToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/iotSalesIncentiveChallengeDeals`,
  collabToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/collabChampionsLeagueChallengeDeals`,
  customChallenge: `${environment.api_url}/rest/customChallenge/`,
  possibleValues: `${environment.api_url}/rest/customChallenge/possibleValues`,
  submitCustomChallenge: `${environment.api_url}/rest/customChallenge`,
  activityChallenge: `${environment.api_url}/rest/possibleValues/activityChallenge`,
  resendApprovalLink: `${environment.api_url}/rest/customChallenge/approveChallenge/resend?`,
  approvalTracker: `${environment.api_url}/rest/customChallenge/approvalTracker`,
  newSalesChallenge: `${environment.api_url}/rest/eligibleDeals/summary/company`,
  challengeDetails: `${environment.api_url}/rest/eligibleDeals/challengeEligibility/details`,
  claimByPoSeller: `${environment.api_url}/rest/claims/v2/claim/poNumber?`,
  cloneChallenge: `${environment.api_url}/rest/customChallenge/clone/`,
  pointActivitySeller: `${environment.api_url}/rest/dashboard/graphs/user/pointsActivity?`,
  ticketActivity: `${environment.api_url}/rest/dashboard/graphs/user/ticketsActivity?`,
  salesChallengePerformence: `${environment.api_url}/rest/dashboard/graphs/seller/salesChallengePerformance?`,
  claimStatusSummary: `${environment.api_url}/rest/dashboard/graphs/user/claimStatusSummary?`,
  statisticsData: `${environment.api_url}/rest/dashboard/seller/statistics/`,
  distributedPointActivity: `${environment.api_url}/rest/dashboard/graphs/distributed/pointsActivity?`,
  salesActivityData: `${environment.api_url}/rest/dashboard/graphs/seller/salesActivity?`,
  claimStatusHistory: `${environment.api_url}/rest/claims/seller/pointsClaimedAndEarnedHistory`,
  uploadActivityChallengeDocuments: `${environment.api_url}/rest/activityChallenges/uploadAttachment`,
  uploadCompletion: `${environment.api_url}/rest/utils/forceMarkParticipationActChAsCompleted`,
  cashBreakdown: `${environment.api_url}/rest/points/user/cash/breakdown`,
  pointsExpiryTracker:`${environment.api_url}/rest/points/user/pointsExpiryTracker`,
};

export const managerApi = {
  getAllChallengeTypes: `${environment.api_url}/rest/challengeTypes`,
  getQuizChallengeTypes: `${environment.api_url}/rest/challengeTypes?includeInternal=true`,
  getChallengesByManager: `${environment.api_url}/rest/challenges/manager`,
  getChallengesParticipants: `${environment.api_url}/rest/activityChallenges/moreInfo`,
  getUsersUnderManager: `${environment.api_url}/rest/users/search/manager`,
  getPrescribedEnablementsManager: `${environment.api_url}/rest/prescribedenablements/manager`,
  postChallenge: `${environment.api_url}/rest/challenges/`,
  getArchitectureTypes: `${environment.api_url}/rest/architectureTypes`,
  getEnablementCourses: `${environment.api_url}/rest/courses`,
  getTypesAndLearningMaps: `${environment.api_url}/rest/learningMaps/typesAndLearningMaps`,
  getTypesAndCourses: `${environment.api_url}/rest/courses/typesAndCourses`,
  postEnablement: `${environment.api_url}/rest/prescribedenablements/enablement`,
  getCompanyCreditsAvailable: `${environment.api_url}/rest/credits/company/available`,
  getCompanyTypePreferences: `${environment.api_url}/rest/preferences/type/company`,
  getSellerTypePreferences: `${environment.api_url}/rest/preferences/type/seller`,
  companyPreferences: `${environment.api_url}/rest/preferences/company`,
  companyListPreferences: `${environment.api_url}/rest/preferences/company/list`,
  sellerPreferences: `${environment.api_url}/rest/preferences/sellers`,
  postSellerPreferences: `${environment.api_url}/rest/preferences/user`,
  getCompanyPoints: `${environment.api_url}/rest/points/distribute/company`,
  getCompanyUsersPoints: `${environment.api_url}/rest/points/distribute/company/{companyId}/users`,
  updateSingleUserPoints: `${environment.api_url}/rest/points/distribute/user/update`,
  fiscalPeriod: `${environment.api_url}/rest/fiscalperiod/endDateOfQuarter`,
  deleteChallenge: `${environment.api_url}/rest/challenges/delete`,
  updateMultipleUserPoints: `${environment.api_url}/rest/points/distribute/user/update/multiple`,
  adminClaimForUser: `${environment.api_url}/rest/claims/claim/deal`,
  adminClaimall: `${environment.api_url}/rest/claims/claim/claimAll`,
  datacenterClaimall: `${environment.api_url}/rest/claims/claim/claimAllDataCenter`,
  nexusClaimall: `${environment.api_url}/rest/claims/claim/claimAllNexus`,
  flexToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/flipFlexChallengeDeals`,
  flexClaimall: `${environment.api_url}/rest/claims/claim/claimAllFlip2Flex`,
  webexToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/webexChallengeDeals`,
  webexClaimall: `${environment.api_url}/rest/claims/claim/claimAllWebex`,
  securityRewardToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/securityRewardsChallengeDeals`,
  securityRewardClaimall: `${environment.api_url}/rest/claims/claim/claimAllSecurityRewards`,
  wirelessAcceToClaimedToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/wirelessAccelerationChallengeDeals`,
  wirelessAccClaimall: `${environment.api_url}/rest/claims/claim/claimAllWirelessAcceleration`,
  mdsRewardToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/mdsRewardsChallengeDeals`,
  mdsRewardClaimall: `${environment.api_url}/rest/claims/claim/claimAllMdsRewards`,
  sdwanAccelerationToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/sdwanAccelerationChallengeDeals`,
  sdwanAccelerationClaimall: `${environment.api_url}/rest/claims/claim/claimAllSdwanAcceleration`,
  collaborationSprintClaimAll: `${environment.api_url}/rest/claims/claim/claimAllCollaborationSprint`,
  poSearchResult: `${environment.api_url}/rest/eligibleDeals/poSearch`,
  pointAccountSellerClaimedBySeller: `${environment.api_url}/rest/claims/company/pointsClaimedAndEarnedHistory`,
  pointAccountClaimedByAdmin: `${environment.api_url}/rest/points/company/pointsTransactionHistory`,
  enterpriseNetworkToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/enterpriseNetworkingAccelerationChallengeDeals`,
  enterproseNetworkClaimall: `${environment.api_url}/rest/claims/claim/claimAllEnterpriseNetworkingAcceleration`,
  designedPortfolioToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/designedPortfolioChallengeDeals`,
  designedPortfolioClaimall: `${environment.api_url}/rest/claims/claim/claimAllDesignedPortfolio`,
  cloudCallingToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/cloudCallingChallengeDeals`,
  cloudCallingClaimall: `${environment.api_url}/rest/claims/claim/claimAllCloudCalling`,
  pointAccountRedemptionTaxStatement: `${environment.api_url}/rest/points/companyRedemptionTaxStatement`,
  merakiToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/blackBeltMerakiChallengeDeals`,
  dnaToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/dnacApplianceChallengeDeals`,
  dnaClaimall: `${environment.api_url}/rest/claims/claim/claimAllDnacAppliance`,
  wanToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/competitiveTakeoutChallengeDeals`,
  wanClaimall: `${environment.api_url}/rest/claims/claim/claimAllSdwanAcceleration`,
  saseToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/saseChallengeDeals`,
  saseClaimall: `${environment.api_url}/rest/claims/claim/claimAllSase`,
  ibnToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/ibnWanChallengeDeals`,
  ibnClaimall: `${environment.api_url}/rest/claims/claim/claimAllIbnWan`,
  getBudgetCapBars: `${environment.api_url}/rest/budgetCap/getRewardCapStatsForChallenge`,
  eaToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/enterpriseAgreementsAccelerationRewardsChallengeDeals`,
  eaClaimall: `${environment.api_url}/rest/claims/claim/claimAllEnterpriseAgreementsRewards`,
  officeToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/returnToOfficeChallengeDeals`,
  officeClaimall: `${environment.api_url}/rest/claims/claim/claimAllReturnToOffice`,
  iotsalesToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/iotSalesIncentiveChallengeDeals`,
  iotsalesClaimall: `${environment.api_url}/rest/claims/claim/claimAlliotIncentive`,
  collabToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/collabChampionsLeagueChallengeDeals`,
  collabClaimall: `${environment.api_url}/rest/claims/claim/claimAllCollabChampions`,
  intersightToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/intersightAdoptionChallengeDeals`,
  intersightClaimall: `${environment.api_url}/rest/claims/claim/intersightAdoptionChallengeDeals`,
  ealToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/enterpriseAgreementLifecycleChallengeDeals`,
  ealClaimall: `${environment.api_url}/rest/claims/claim/claimAllEnterpriseAgreementLifecycle`,
  ciscoCloudCallingToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/flexCloudCallingChallengeDeals`,
  ciscoCloudCallingClaimall: `${environment.api_url}/rest/claims/claim/claimAllFlexCloudCalling`,
  ciscoCloudContactToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/cloudContactCenterChallengeDeals`,
  ciscoCloudContactClaimall: `${environment.api_url}/rest/claims/claim/claimAllCloudContactCenter`,
  massScaleInfrastructureChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/massScaleInfrastructureChallengeDeals`,
  massScaleInfrastructureChallengeDealsClaimAll: `${environment.api_url}/rest/claims/claim/claimAllMassScaleInfrastructure`,
  fastStartChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/fastStartChallengeDeals`,
  fastStartChallengeDealsClaimAll: `${environment.api_url}/rest/claims/claim/claimAllFastStart`,
  doubleUpSecurityChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/doubleUpSecurityChallengeDeals`,
  claimAllDoubleUpSecurity: `${environment.api_url}/rest/claims/claim/claimAllDoubleUpSecurity`,
  salesAccelerationChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/salesAccelerationChallengeDeals`,
  hybridWorkSalesAccelerationChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/hybridWorkSalesAccelerationChallengeDeals`,
  boostForSmallBusinessSalesChallengeDealsToClaimed: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/boostForSmallBusinessSalesChallengeDeals`,
  claimAllBoostForSmallBusiness: `${environment.api_url}/rest/claims/claim/claimAllBoostForSmallBusiness`,
  bigMerakiSalesChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/bigMerakiSalesChallengeDeals`,
  sellTheSuiteSalesChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/sellTheSuiteSalesChallengeDeals`,
  claimAllSellTheSuite: `${environment.api_url}/rest/claims/claim/claimAllSellTheSuite`,
  commercialSellerChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/commercialSellerChallengeDeals`,
  claimAllCommercialSeller: `${environment.api_url}/rest/claims/claim/claimAllCommercialSeller`,
  mspSalesAccelerationChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/mspSalesAccelerationChallengeDeals`,
  aacpcSalesChallenge: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/aacpcSalesChallengeDeals`,
  claimAllAacpc: `${environment.api_url}/rest/claims/claim/claimAllAacpc`,
  webMediaSalesChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/webMediaSalesChallengeDeals`,
  claimAllWebMedia: `${environment.api_url}/rest/claims/claim/claimAllWebMedia`,
  newCloudCallingChallengeDeals: `${environment.api_url}/rest/eligibleDeals/company/{companyId}/newCloudCallingChallengeDeals`,
  claimAllNewCloudCalling: `${environment.api_url}/rest/claims/claim/claimAllNewCloudCalling`,
  viewChallenge: `${environment.api_url}/rest/customChallenge/creator/`,
  countryGroupList: `${environment.api_url}/rest/countryGroups/list`,
  submitForApproval: `${environment.api_url}/rest/customChallenge/updateStatus?`,
  salesChallengeeligibleDeals: `${environment.api_url}/rest/eligibleDeals/`,
  claimAllChallengeDeals: `${environment.api_url}/rest/claims/`,
  approvalTracker: `${environment.api_url}/rest/customChallenge/approvalTracker?`,
  claimAll: `${environment.api_url}/rest/claims/claimAllByCompanyId`,
  pointActivityLeader: `${environment.api_url}/rest/dashboard/graphs/company/pointsActivity?`,
  ticketActivityLeader: `${environment.api_url}/rest/dashboard/graphs/company/ticketsActivity?`,
  salesChallengePerformence: `${environment.api_url}/rest/dashboard/graphs/company/salesChallengePerformance?`,
  claimStatusSummary: `${environment.api_url}/rest/dashboard/graphs/company/claimStatusSummary?`,
  statisticsData: `${environment.api_url}/rest/dashboard/manager/statistics/`,
  distributedPointActivity: `${environment.api_url}/rest/dashboard/graphs/distributed/company/pointsActivity?`,
  createBookingChallenge: `${environment.api_url}/rest/activityChallenges/booking`,
  createTrainingChallenge: `${environment.api_url}/rest/activityChallenges/enablement`,
  createArchitectureChallenge: `${environment.api_url}/rest/activityChallenges/architecture`,
  getBookingChallengeById: `${environment.api_url}/rest/activityChallenges/booking/`,
  getTrainingChallengeById: `${environment.api_url}/rest/activityChallenges/enablement/`,
  getArchitectureChallengeById: `${environment.api_url}/rest/activityChallenges/architecture/`,
  deleteActivityChallenge: `${environment.api_url}/rest/activityChallenges/delete`,
  updateStatus: `${environment.api_url}/rest/activityChallenges/updateStatus`,
  fiscalOptions: `${environment.api_url}/rest/activityChallenges/quarters/select/options`,
  getParticipantsChallenge: `${environment.api_url}/rest/activityChallenges/participants/`,
  createParticipantsChallenge: `${environment.api_url}/rest/activityChallenges/participants`,
  salesActivityData: `${environment.api_url}/rest/dashboard/graphs/company/salesActivity?`,
  claimStatusHistory: `${environment.api_url}/rest/claims/company/pointsClaimedAndEarnedHistory`,
  getCompanyUsersPointsExcel: `${environment.api_url}/rest/points/distributed/company/{companyId}/users`,
  activityChallenge: `${environment.api_url}/rest/possibleValues/activityChallenge`,
  createProductsBooking: `${environment.api_url}/rest/activityChallenges/productsBooking`,
  getCountryListByRegion: `${environment.api_url}/rest/regionCountryMappings/byRegions`,
  getProductBookingById: `${environment.api_url}/rest/activityChallenges/productsBooking/`,
  getProductBookingProgress: `${environment.api_url}/rest/activityChallenges/productsBooking/progressInfo/`,
  getCustomChallenges: `${environment.api_url}/rest/dashboard/getCustomChallenges`,
  getAdminActivityChallenge: `${environment.api_url}/rest/activityChallenges/`,
  getActivityChallengesByManagerId: `${environment.api_url}/rest/activityChallenges/manager/`,
  postActivityChallenge: `${environment.api_url}/rest/activityChallenges/`,
  deleteActiveChallenge: `${environment.api_url}/rest/activityChallenges/delete`,
  cloneActivityChallenge: `${environment.api_url}/rest/activityChallenges/clone/`,
  checkOverrideFromAutoToManual: `${environment.api_url}/rest/preferences/overrideAutoToManualDistribution`,
  submitProof: `${environment.api_url}/rest/actch/uploads/userChallengeId`,
  proofOfDocuments: `${environment.api_url}/rest/actch/uploads`,
  docTypesList: `${environment.api_url}/rest/actch/uploads/docTypes`,
  getCommentsByFileId: `${environment.api_url}/rest/actch/uploads/getComments`,
  addCommentsByFileId: `${environment.api_url}/rest/actch/uploads/updateComments`,
  createLeaderboardChallenge: `${environment.api_url}/rest/leaderboardChallenges/productsBooking`,
  getLeaderBoardChallengesListCiscoAdmin: `${environment.api_url}/rest/leaderboardChallenges/list/cadmin`,
  getLeaderBoardChallengesListLeader: `${environment.api_url}/rest/leaderboardChallenges/list/leader`,
  getLeaderBoardChallengesListSeller: `${environment.api_url}/rest/leaderboardChallenges/list/assignedToUser`,
  getLeaderBoardChallengeById: `${environment.api_url}/rest/leaderboardChallenges/productsBooking/`,
  deleteLeaderboardChallengeById: `${environment.api_url}/rest/leaderboardChallenges/delete`,
  updateLeaderboardChallengeStatus: `${environment.api_url}/rest/leaderboardChallenges/updateStatus`,
  cloneLeaderboardChallengeById: `${environment.api_url}/rest/leaderboardChallenges/clone/productsBooking/`,
  activityFiscalOptions: `${environment.api_url}/rest/activityChallenges/fiscalPeriods`,
  activeLeaderboardChallenge: `${environment.api_url}/rest/leaderboardChallenges/activeleaderboardChallenges`,
  getLeaderboardChallengeProgress: `${environment.api_url}/rest/leaderboardChallenges/progressInfo/`,
  acPossibleValues: `${environment.api_url}/rest/actCh/possibleValues`,
  enablementCourseTypes: `${environment.api_url}/rest/enablementCourseTypes`,
  rebatecoordinators: `${environment.api_url}/rest/rebatecoordinators/save`,
  getRebateCoordinators: `${environment.api_url}/rest/rebatecoordinators/getRebateCoordinatorsByCompany?`,
  generateTandConditionsFile: `${environment.api_url}/rest/customChallenge/generateTandCDocumentationAsDownloadable?`,
  generateEligProductsDocumentationAsDownloadable: `${environment.api_url}/rest/customChallenge/generateEligProductsDocumentationAsDownloadable?`,
  getQuaterLevelBudget:`${environment.api_url}/rest/customChallenge/quarterlyLevelBudgets/list/all?`,
  saveQuarterLevelBudget:`${environment.api_url}/rest/customChallenge/quarterlyLevelBudgets`,
  updateBudgetcapData:`${environment.api_url}/rest/customChallenge/quarterlyLevelBudgets`
};

export const footerLinksApi = {
  postSupportRequest: `${environment.api_url}/rest/support/submit/ticket`,
  getSupportCategory: `${environment.api_url}/rest/support/categories?`,
  getBannerWidgetapi: `${environment.api_url}/bunchball/rest/auth-token`,
  getBanner: `${environment.api_url}/rest/banners/findByRegionAndConsole`,
  checkUserCanAccessQuiz: `${environment.api_url}/rest/challenges/canUserAccessOpenHouseTourQuizLeaderV2`,
  quizMetaInfoString: `${environment.api_url}/rest/quiz/view/key/`,
  quizMetaInfoNumber: `${environment.api_url}/rest/quiz/view/`,
  quizData: `${environment.api_url}/rest/quiz/take/`,
  saveQuizAnswer: `${environment.api_url}/rest/quiz/saveAnswer`,
  submitQuiz: `${environment.api_url}/rest/quiz/submit`,
  reviewQuiz: `${environment.api_url}/rest/quiz/review/`,
  getQuizId: `${environment.api_url}/rest/quiz/getQuizDateAndIds`,
  getSliderImages: `${environment.api_url}/rest/scrollbanners/getScrollBanners`,
};

export const maintenanceLink = {
  getMaintenanceMessage: `${environment.maintenanceUrl}/rest/maintenance`,
};

export const PAMUserApi = {
  getTheatersRequest: `${environment.api_url}/rest/pam/getTheaters/`,
  getCountryGroupsRequest: `${environment.api_url}/rest/pam/getCountryGroups/`,
  getBeGeoIdsRequest: `${environment.api_url}/rest/pam/getBeGeoIds`,
};

export const quizChallengeApi = {
  createQuizChallenge: `${environment.api_url}/rest/activityChallenges/quiz`,
  uploadQuizBanner: `${environment.api_url}/rest/activityChallenges/upload-quiz-banner?`,
  getQuizChallengeList: `${environment.api_url}/rest/activityChallenges/all/cadmin`,
  getQuizData: `${environment.api_url}/rest/activityChallenges/quiz/`,
};

export const winnerPageApi = {
  getdropdownOptions: `${environment.api_url}/rest/quarterlyWinners/dropdownOptions`,
  getquarterlyWinnersData: `${environment.api_url}/rest/quarterlyWinners/list`,
};

export const approverApi = {
  getActivityList: `${environment.api_url}/rest/activityChallenges/approvers/actChlist`,
  getActivityGridData: `${environment.api_url}/rest/activityChallenges/approvers/list/allFiles`,
  approverUpdateStatus: `${environment.api_url}/rest/actch/uploads/updateStatus`,
  getApprovalCount: `${environment.api_url}/rest/actch/uploads/stats/actChId/`,
  getApproverlistBySearch: `${environment.api_url}/rest/activityChallenges/approvers/list/allFiles?`,
};

export const cashpaymentApi = {
  getVendorLevelStatus: `${environment.api_url}/rest/cashpayments/list/vendorLevelStatuses`,
  getVendorData: `${environment.api_url}/rest/cashpayments/list/byCashVendor`,
  getPartnerLevelStatus: `${environment.api_url}/rest/cashpayments/list/partnerLevelStatuses`,
  getVendorLevelBreakdownData: `${environment.api_url}/rest/cashpayments/list/byCashVendor/breakdown`,
  getCashpaymentByPartner: `${environment.api_url}/rest/cashpayments/list/byPartner`,
  getcashpaymentVendorlevelStatusHistory: `${environment.api_url}/rest/cashpayments/statusTracker/cashPaymentVendorLevel?`,
  getcashpaymentPartnerLevelStatusHistory: `${environment.api_url}/rest/cashpayments/statusTracker/cashPaymentPartnerLevel?`,
  getByPartnerBreakdownList: `${environment.api_url}/rest/cashpayments/list/byPartner/breakdown?`,
  updateStatusOfCashpaymentAtVendorLevel: `${environment.api_url}/rest/cashpayments/updateStatus`,
  downloadPaymentFile: `${environment.api_url}/rest/cashpayments/generateVistexPaymentFile?`,
  uploadVistexPaymentFIle: `${environment.api_url}/rest/cashpayments/uploadVistexPaymentStatusFile?`,
  getPartnerConsolidatedList: `${environment.api_url}/rest/cashpayments/list/byPartner/consolidated?`,
  getPartnerLeaderBreakdownData: `${environment.api_url}/rest/cashpayments/list/byPartner/consolidated/breakdown/users?`,
  getPartnerLeaderStatusHistory: `${environment.api_url}/rest/cashpayments/statusTracker/cashPaymentPartnerLevel/consolidated?`,
  getPartnerConsolidatedBreakdownRun: `${environment.api_url}/rest/cashpayments/list/byPartner/consolidated/breakdown/runs?`,
  postSubmitProofOfPayment: `${environment.api_url}/rest/cashpayments/submitProofOfPayment`,
  getByuserConsolidatedData: `${environment.api_url}/rest/cashpayments/list/byUser/consolidated?`,
  getbyUserStatusList: `${environment.api_url}/rest/cashpayments/list/sellerLevelStatuses`,
  getPolevelBreakdownData: `${environment.api_url}/rest/cashpayments/list/byPartner/consolidated/breakdown/users/polevel?`,
};
export const acknowledgementApi = {
  getAcknowledgements: `${environment.api_url}/rest/acknowledgements/getAcknowledgements?console=`,
  captureUserAcknowledgement: `${environment.api_url}/rest/acknowledgements/captureUserAcknowledgement`,
};

export const budgetcapApi = {
  getBudgets: `${environment.api_url}/rest/customChallenge/getBudgets?`,
  updateBudgets: `${environment.api_url}/rest/customChallenge/updateBudgets`,
};

export const badgingApi = {
  getRegularBadgesList: `${environment.api_url}/rest/badges/user/listRegularBadges`,
  getCreatedRegularBadgesList: `${environment.api_url}/rest/badges/user/listCreatedRegularBadges`,
  getPeerBadgesList: `${environment.api_url}/rest/badges/user/listPeerBadges`,
  getLevelData: `${environment.api_url}/rest/badges/user/getLevelData`, // change later for actual api url
  getTrackData: `${environment.api_url}/rest/badges/user/getTrackData`, // change later for actual api url
  createBadge: `${environment.api_url}/rest/badges`,
  deleteBadge: `${environment.api_url}/rest/badges/delete`,
}